import React from 'react';

const initial = {};
const LoyaltyContext = React.createContext(initial);

export default LoyaltyContext;
